import React from 'react';
import PropTypes from 'prop-types';

/**
 * Plantilla de listado moderna (estilo dashboard clínico).
 * Solo presentación: title / actions / filters / children.
 */
const ListPage = ({ title, subtitle, actions, filters, children, className }) => (
  <div className={'list-page' + (className ? ' ' + className : '')}>
    <div className="list-page__toolbar">
      <div className="list-page__heading">
        {title ? <h2 className="list-page__title">{title}</h2> : null}
        {subtitle ? <p className="list-page__subtitle">{subtitle}</p> : null}
      </div>
      {actions ? <div className="list-page__actions"><div className="action-group">{actions}</div></div> : null}
    </div>
    {filters ? <div className="list-page__filters">{filters}</div> : null}
    <div className="list-page__body">{children}</div>
  </div>
);

ListPage.defaultProps = {
  title: '',
  subtitle: '',
  actions: null,
  filters: null,
  className: ''
};

ListPage.propTypes = {
  title: PropTypes.node,
  subtitle: PropTypes.node,
  actions: PropTypes.node,
  filters: PropTypes.node,
  children: PropTypes.node,
  className: PropTypes.string
};

export default ListPage;
